import { render, staticRenderFns } from "./ProviderStats.vue?vue&type=template&id=07636bb2&"
import script from "./ProviderStats.vue?vue&type=script&lang=js&"
export * from "./ProviderStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports